import { DropdownMenu as DM } from 'radix-ui';
import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export const DropdownMenu = DM.Root;
export const DropdownTrigger = DM.Trigger;

export function DropdownContent({ children, align = 'end', className }: { children: ReactNode; align?: 'start' | 'end'; className?: string }) {
  return (
    <DM.Portal>
      <DM.Content
        align={align}
        sideOffset={6}
        className={cn('fx-menu z-50 min-w-48 rounded-xl border border-border bg-surface/90 p-1 shadow-(--shadow-pop) backdrop-blur-xl backdrop-saturate-150', className)}
      >
        {children}
      </DM.Content>
    </DM.Portal>
  );
}

export function DropdownItem({ children, onSelect, danger, disabled }: { children: ReactNode; onSelect?: () => void; danger?: boolean; disabled?: boolean }) {
  return (
    <DM.Item
      disabled={disabled}
      onSelect={onSelect}
      className={cn(
        'flex cursor-pointer items-center gap-2 rounded-md px-2.5 py-1.5 text-sm outline-none transition-[background-color,color,padding] duration-150 select-none data-[highlighted]:pl-3 data-[disabled]:pointer-events-none data-[disabled]:opacity-50 data-[highlighted]:bg-primary-soft data-[highlighted]:text-primary [&_svg]:size-4 [&_svg]:text-fg-subtle data-[highlighted]:[&_svg]:text-primary',
        danger && 'text-danger [&_svg]:text-danger',
      )}
    >
      {children}
    </DM.Item>
  );
}

export const DropdownSeparator = () => <DM.Separator className="my-1 h-px bg-border" />;
export const DropdownLabel = ({ children }: { children: ReactNode }) => (
  <DM.Label className="px-2.5 py-1.5 text-xs text-fg-subtle">{children}</DM.Label>
);
